import { newportInstructions } from 'communication/streaming/StreamingErrorText';

export interface NewportLoginErrorText {
    title: string;
    instructions: string;
}

export const newportLoginErrors = (reloadPossible: boolean) => ({
    login401: {
        title: 'Newport authentication failure.',
        instructions:
            newportInstructions(reloadPossible).pleaseRefreshBySelecting,
    },
    login500: {
        title: 'Unexpected error during authentication.',
        instructions:
            newportInstructions(reloadPossible).pleaseCloseAndRelaunch,
    },
    invalidKey: {
        title: 'Invalid credentials received from Newport.',
        instructions:
            newportInstructions(reloadPossible).pleaseCloseAndRelaunch,
    },
});

export function buildNewportLoginErrorTextFromLoginStatus(
    status?: number,
    reloadPossible = false
) {
    if (status === 401) {
        return newportLoginErrors(reloadPossible).login401;
    } else {
        return newportLoginErrors(reloadPossible).login500;
    }
}
